import React, { useState, useEffect } from 'react'
import './index.less'

type SJScreenDialogProps = {
  title: string // 标题
  visible: boolean // 显示
  onVisibleChange: (val: boolean) => void
  className?: string
  children?: React.ReactNode
}

const SJScreenDialog: React.FC<SJScreenDialogProps> = ({
  className,
  title,
  visible,
  onVisibleChange,
  children,
  ...props
}) => {
  const [show, setShow] = useState(false)

  const onMaskClick = () => {
    setShow(false)
    onVisibleChange(false)
  }
  const onScrollClick = (e: any) => {
    e.stopPropagation()
  }
  useEffect(() => {
    setShow(visible)
  }, [visible])
  return (
    <div
      className={`sc-screendialog-mask ${className ?? ''} ${visible && 'sc-screendialog-visible'}`}
      onClick={onMaskClick}
      {...props}
    >
      <div className={`sc-screendialog ${show ? 'show' : 'hide'}`} onClick={onScrollClick}>
        <div className="sc-screendialog-header">
          <div className="sc-screendialog-header-title">{title}</div>
          {/* <div className='sc-screendialog-header-tip'>使用说明</div> */}
        </div>
        <div className="sc-screendialog-body">{children}</div>
      </div>
    </div>
  )
}

export default SJScreenDialog
